module.exports = __webpack_public_path__ + "img/BGMain2.1a3bb20c.jpg";